import React, { useState, useEffect } from 'react';
import {
  Typography,
  Box,
  Container,
  Grid,
  Paper,
  Card,
  CardContent,
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Tabs,
  Tab,
  // Tooltip, // Kullanılmıyor
  IconButton,
  Stack,
  Button, // Bu satırı aktif hale getirdik, artık yorum satırı değil
  Chip,
  LinearProgress,
  Alert,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Avatar,
  // Rating, // Kullanılmıyor
  // Slider // Kullanılmıyor
} from '@mui/material';
import {
  LineChart,
  Line,
  // BarChart, // Kullanılmıyor
  // Bar, // Kullanılmıyor
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip as RechartsTooltip,
  Legend,
  ResponsiveContainer,
  // PieChart, // Kullanılmıyor
  // Pie, // Kullanılmıyor
  // Cell, // Kullanılmıyor
  // ScatterChart, // Kullanılmıyor
  // Scatter, // Kullanılmıyor
  // Area, // Kullanılmıyor
  // AreaChart, // Kullanılmıyor
  // ReferenceLine // Kullanılmıyor
} from 'recharts';
import RefreshIcon from '@mui/icons-material/Refresh';
import WarningIcon from '@mui/icons-material/Warning';
import EngineeringIcon from '@mui/icons-material/Engineering';
import BuildIcon from '@mui/icons-material/Build';
// import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest'; // Kullanılmıyor
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
// import FileDownloadIcon from '@mui/icons-material/FileDownload'; // Kullanılmıyor
import AnalyticsIcon from '@mui/icons-material/Analytics';
// import ConstructionIcon from '@mui/icons-material/Construction'; // Kullanılmıyor
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import TrendingUpIcon from '@mui/icons-material/TrendingUp'; // Bu import eksikti, ekledik
import AnimatedNumber from '../../components/common/AnimatedNumber';

// Renk Paleti - İleride kullanılabilir olduğundan yorum satırı olarak koruyalım
// const COLORS = ['#4caf50', '#ff9800', '#f44336', '#3f51b5', '#9c27b0', '#e91e63', '#2196f3', '#00bcd4'];

// Makine durumu için sabitler
const MACHINE_STATUS = {
  HEALTHY: {
    label: 'Sağlıklı',
    color: '#4caf50',
    icon: <CheckCircleIcon />
  },
  WARNING: {
    label: 'İzlenmeli',
    color: '#ff9800',
    icon: <WarningIcon />
  },
  CRITICAL: {
    label: 'Kritik',
    color: '#f44336',
    icon: <ErrorIcon />
  },
  MAINTENANCE: {
    label: 'Bakımda',
    color: '#2196f3',
    icon: <BuildIcon />
  }
};

// Makine bakım geçmişi tablo sütunları
const TABLE_COLUMNS = [
  { id: 'date', label: 'Tarih', align: 'left' },
  { id: 'type', label: 'Bakım Türü', align: 'left' },
  { id: 'duration', label: 'Süre (saat)', align: 'right' },
  { id: 'cost', label: 'Maliyet (₺)', align: 'right' },
  { id: 'technician', label: 'Teknisyen', align: 'left' },
  { id: 'status', label: 'Durum', align: 'center' }
];

// Demo verisi üretme fonksiyonları
const generateMachines = () => {
  const machineTypes = [
    { name: 'Konveyör Sistemi', systems: ['Motor', 'Kayış', 'Rulman', 'Sensör'] },
    { name: 'CNC Tezgahı', systems: ['Kesici', 'Soğutma', 'Motor', 'Kontrol Ünitesi'] },
    { name: 'Robot Kol', systems: ['Eklem Motoru', 'Pnömatik', 'Sensör', 'Kontrolcü'] },
    { name: 'Paketleme Makinesi', systems: ['Enerji Ünitesi', 'Sensör', 'Silindir', 'Aktüatör'] },
    { name: 'Hidrolik Pres', systems: ['Pompa', 'Valf', 'Silindir', 'Basınç Sensörü'] }
  ];
  
  const locations = ['Üretim Hattı A', 'Üretim Hattı B', 'Üretim Hattı C', 'Montaj Hattı', 'Depo'];
  
  const machines = [];
  
  for (let i = 1; i <= 20; i++) {
    const machineType = machineTypes[Math.floor(Math.random() * machineTypes.length)];
    const healthScore = Math.floor(Math.random() * 101); // 0-100 arası skor
    
    // Sağlık skoruna göre durum belirleme
    let status;
    if (healthScore >= 80) status = 'HEALTHY';
    else if (healthScore >= 50) status = 'WARNING';
    else status = 'CRITICAL';
    
    // Rastgele bazı makineleri bakım durumuna al
    if (Math.random() < 0.1) status = 'MAINTENANCE';
    
    // Bakıma kalan gün hesaplama
    const daysToMaintenance = status === 'CRITICAL' 
      ? Math.floor(Math.random() * 5) 
      : status === 'WARNING'
        ? 5 + Math.floor(Math.random() * 10)
        : 15 + Math.floor(Math.random() * 20);
    
    // Kritik parçalar
    const systems = machineType.systems.map(system => ({
      name: system,
      health: Math.floor(Math.random() * 101), // 0-100 arası sağlık
      lastMaintenanceDate: randomDate(new Date(2023, 0, 1), new Date())
    }));
    
    // En düşük sağlık değerine sahip parçayı bul (kritik parça)
    const criticalSystem = [...systems].sort((a, b) => a.health - b.health)[0];
    
    machines.push({
      id: `M${String(i).padStart(3, '0')}`,
      name: `${machineType.name} ${i}`,
      type: machineType.name,
      location: locations[Math.floor(Math.random() * locations.length)],
      installationDate: randomDate(new Date(2018, 0, 1), new Date(2022, 11, 31)),
      status,
      healthScore,
      runningHours: Math.floor(1000 + Math.random() * 9000),
      efficiency: Math.floor(60 + Math.random() * 40),
      daysToMaintenance,
      maintenanceHistory: generateMaintenanceHistory(),
      sensorData: generateSensorData(),
      systems,
      criticalSystem,
      alertCount: Math.floor(Math.random() * (status === 'CRITICAL' ? 10 : status === 'WARNING' ? 5 : 2)),
      lastAlert: status === 'CRITICAL' ? randomDate(new Date(Date.now() - 24 * 60 * 60 * 1000), new Date()) : null
    });
  }
  
  return machines;
};

// Rastgele tarih oluşturma yardımcı fonksiyonu
function randomDate(start, end) {
  return new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime())).toISOString().split('T')[0];
}

// Bakım geçmişi oluşturma
function generateMaintenanceHistory() {
  const history = [];
  const maintenanceTypes = ['Planlı Bakım', 'Acil Onarım', 'Parça Değişimi', 'Yağlama', 'Kalibrasyon'];
  const technicians = ['Ahmet Yılmaz', 'Mehmet Demir', 'Ayşe Kaya', 'Ali Öztürk', 'Zeynep Çelik'];
  
  // 0-5 arası rastgele bakım kaydı oluştur
  const count = Math.floor(Math.random() * 6);
  
  for (let i = 0; i < count; i++) {
    history.push({
      id: `M${i}`,
      date: randomDate(new Date(2022, 0, 1), new Date()),
      type: maintenanceTypes[Math.floor(Math.random() * maintenanceTypes.length)],
      duration: Math.floor(1 + Math.random() * 8),
      cost: Math.floor(500 + Math.random() * 4500),
      technician: technicians[Math.floor(Math.random() * technicians.length)],
      notes: 'Rutin bakım ve kontrol yapıldı.',
      status: Math.random() > 0.1 ? 'Tamamlandı' : 'Devam Ediyor'
    });
  }
  
  // Tarihe göre sırala (en yeni en üstte)
  return history.sort((a, b) => new Date(b.date) - new Date(a.date));
}

// Sensör verisi oluşturma
function generateSensorData() {
  const data = [];
  const now = new Date();
  
  // Son 30 gün için veri üret
  for (let i = 29; i >= 0; i--) {
    const date = new Date(now);
    date.setDate(date.getDate() - i);
    
    // Biraz trend ekle - zamanla kötüleşen performans
    const degradationFactor = 1 - (i / 100); // 0.71 ile 1 arası
    
    // Rastgele dalgalanmalar ekle
    const randomFactor = 0.85 + (Math.random() * 0.3);
    
    data.push({
      date: date.toISOString().split('T')[0],
      vibration: Math.round((2 + Math.random() * 3) * degradationFactor * randomFactor * 100) / 100,
      temperature: Math.round((50 + Math.random() * 20) * degradationFactor * randomFactor * 10) / 10,
      noise: Math.round((40 + Math.random() * 30) * degradationFactor * randomFactor * 10) / 10,
      pressure: Math.round((80 + Math.random() * 20) * (1 / degradationFactor) * randomFactor * 10) / 10,
      day: i
    });
  }
  
  return data;
}

// Toplam özet metrikleri oluşturma
function calculateSummaryMetrics(machines) {
  const totalMachines = machines.length;
  const healthyCount = machines.filter(m => m.status === 'HEALTHY').length;
  const warningCount = machines.filter(m => m.status === 'WARNING').length;
  const criticalCount = machines.filter(m => m.status === 'CRITICAL').length;
  const maintenanceCount = machines.filter(m => m.status === 'MAINTENANCE').length;
  
  const avgHealth = Math.round(machines.reduce((sum, m) => sum + m.healthScore, 0) / totalMachines);
  const avgEfficiency = Math.round(machines.reduce((sum, m) => sum + m.efficiency, 0) / totalMachines);
  
  const totalAlerts = machines.reduce((sum, m) => sum + m.alertCount, 0);
  const failurePrevention = Math.round(75 + Math.random() * 15); // %75-90 arası
  
  return {
    totalMachines,
    healthyCount,
    warningCount,
    criticalCount,
    maintenanceCount,
    avgHealth,
    avgEfficiency,
    totalAlerts,
    failurePrevention
  };
}

// Bakım planlaması için örnek veri oluşturma
const generateMaintenancePlans = (machines) => {
  // Önümüzdeki 30 gün için planlanan bakımlar
  const plans = [];
  const maintenanceTypes = [
    { type: 'Rutin Bakım', duration: '2-4 saat', color: '#4caf50' },
    { type: 'Yağlama', duration: '1-2 saat', color: '#2196f3' },
    { type: 'Parça Değişimi', duration: '4-6 saat', color: '#ff9800' },
    { type: 'Genel Kontrol', duration: '2-3 saat', color: '#9c27b0' },
    { type: 'Kalibrasyon', duration: '3-4 saat', color: '#00bcd4' }
  ];
  
  // Kritik ve uyarı durumundaki makineler için önerilen bakımlar
  machines
    .filter(m => m.status === 'CRITICAL' || m.status === 'WARNING')
    .forEach(machine => {
      // Makine durum bilgisine göre bakım tipi belirle
      const maintenanceIndex = machine.status === 'CRITICAL' ? 2 : // Kritikse parça değişimi
        (machine.healthScore < 60 ? 0 : Math.floor(Math.random() * 5)); // Sağlık skoruna göre farklı bakım tipi
      
      const maintenanceInfo = maintenanceTypes[maintenanceIndex];
      
      // Planlanan tarihi hesapla (kritik makineler için daha yakın tarih)
      const daysToAdd = machine.status === 'CRITICAL' ? 
        Math.floor(Math.random() * 5) + 1 : // 1-5 gün içinde 
        Math.floor(Math.random() * 10) + 5; // 5-15 gün içinde
        
      const today = new Date();
      const plannedDate = new Date(today);
      plannedDate.setDate(today.getDate() + daysToAdd);
      
      // Bakım maliyeti hesapla
      const estimatedCost = ((maintenanceIndex + 1) * 500) + Math.floor(Math.random() * 1000);
      
      // Tahmini süre hesapla
      const estimatedDowntime = parseInt(maintenanceInfo.duration.split('-')[1]);
      
      // Etki analizi - bakım yapılmaması durumunda
      const failureProbability = machine.status === 'CRITICAL' ? 
        Math.floor(75 + Math.random() * 25) : // 75-100%
        Math.floor(30 + Math.random() * 45); // 30-75%
        
      const potentialCostOfFailure = estimatedCost * 4 + Math.floor(Math.random() * 5000);
      
      // Kritik parça bilgisi
      const criticalComponent = machine.criticalSystem;
      
      plans.push({
        id: `MP${plans.length + 1}`,
        machineId: machine.id,
        machineName: machine.name,
        location: machine.location,
        status: machine.status,
        healthScore: machine.healthScore,
        plannedDate: plannedDate.toISOString().split('T')[0],
        maintenanceType: maintenanceInfo.type,
        colorCode: maintenanceInfo.color,
        estimatedDuration: maintenanceInfo.duration,
        estimatedCost,
        estimatedDowntime,
        technician: null, // Henüz atanmadı
        failureProbability,
        potentialCostOfFailure,
        criticalComponent,
        recommendedActions: [
          `${criticalComponent.name} kontrolü`,
          `Yağlama işlemleri`,
          `Sensör kalibrasyonu`
        ],
        priority: machine.status === 'CRITICAL' ? 'Yüksek' : 'Orta',
        roi: Math.round((potentialCostOfFailure - estimatedCost) / estimatedCost * 100)
      });
    });
  
  // Yaklaşan planlı periyodik bakımlar
  machines
    .filter(m => m.status === 'HEALTHY' && m.daysToMaintenance < 20)
    .forEach(machine => {
      const maintenanceInfo = maintenanceTypes[0]; // Rutin bakım
      
      const today = new Date();
      const plannedDate = new Date(today);
      plannedDate.setDate(today.getDate() + machine.daysToMaintenance);
      
      // Bakım maliyeti hesapla (Düşük)
      const estimatedCost = 500 + Math.floor(Math.random() * 300);
      
      // Tahmini süre hesapla (kısa)
      const estimatedDowntime = 2;
      
      plans.push({
        id: `MP${plans.length + 1}`,
        machineId: machine.id,
        machineName: machine.name,
        location: machine.location,
        status: machine.status,
        healthScore: machine.healthScore,
        plannedDate: plannedDate.toISOString().split('T')[0],
        maintenanceType: maintenanceInfo.type,
        colorCode: maintenanceInfo.color,
        estimatedDuration: maintenanceInfo.duration,
        estimatedCost,
        estimatedDowntime,
        technician: null,
        failureProbability: 5 + Math.floor(Math.random() * 10), // 5-15%
        potentialCostOfFailure: estimatedCost * 2 + Math.floor(Math.random() * 1000),
        criticalComponent: machine.systems[Math.floor(Math.random() * machine.systems.length)],
        recommendedActions: [
          'Genel kontrol',
          'Sensör testi'
        ],
        priority: 'Düşük',
        roi: 40 + Math.floor(Math.random() * 40) // 40-80%
      });
    });
    
  // Tarihe göre sırala
  return plans.sort((a, b) => new Date(a.plannedDate) - new Date(b.plannedDate));
};

// Bakım planları için özet metrikler
const calculateMaintenanceSummary = (plans) => {
  return {
    totalPlans: plans.length,
    totalCost: plans.reduce((sum, plan) => sum + plan.estimatedCost, 0),
    totalDowntime: plans.reduce((sum, plan) => sum + plan.estimatedDowntime, 0),
    highPriority: plans.filter(p => p.priority === 'Yüksek').length,
    mediumPriority: plans.filter(p => p.priority === 'Orta').length,
    lowPriority: plans.filter(p => p.priority === 'Düşük').length,
    averageROI: Math.round(plans.reduce((sum, plan) => sum + plan.roi, 0) / plans.length),
    potentialSavings: plans.reduce((sum, plan) => sum + (plan.potentialCostOfFailure - plan.estimatedCost), 0)
  };
};

// Ana Bileşen
const PredictiveMaintenance = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [machinesData, setMachinesData] = useState([]);
  const [selectedMachine, setSelectedMachine] = useState(null);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState({
    location: 'all',
    type: 'all',
    status: 'all'
  });
  const [summaryMetrics, setSummaryMetrics] = useState({});
  // const [timeRange, setTimeRange] = useState(30); // Şimdilik kullanılmıyor
  const [maintenancePlans, setMaintenancePlans] = useState([]);
  const [maintenanceSummary, setMaintenanceSummary] = useState({});
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [timeRange, setTimeRange] = useState(30); // Default to 30 days

  // Veri yükleme
  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      const machines = generateMachines();
      const plans = generateMaintenancePlans(machines);
      
      setMachinesData(machines);
      setSelectedMachine(machines[0]);
      setSummaryMetrics(calculateSummaryMetrics(machines));
      setMaintenancePlans(plans);
      setMaintenanceSummary(calculateMaintenanceSummary(plans));
      setLoading(false);
    }, 1000);
  }, []);
  
  // Tab değişimi
  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };
  
  // Makine seçimi
  const handleMachineSelect = (machine) => {
    setSelectedMachine(machine);
  };
  
  // Filtre değişimi
  const handleFilterChange = (key, value) => {
    setFilter({ ...filter, [key]: value });
  };
  
  // Filtrelenmiş makine listesi
  const filteredMachines = machinesData.filter(machine => {
    return (filter.location === 'all' || machine.location === filter.location) &&
           (filter.type === 'all' || machine.type === filter.type) &&
           (filter.status === 'all' || machine.status === filter.status);
  });
  
  // Konum ve tür için tekil değerleri al
  const locations = [...new Set(machinesData.map(m => m.location))];
  const types = [...new Set(machinesData.map(m => m.type))];
  
  // Makine durumuna göre renk döndürme fonksiyonu
  const getStatusColor = (status) => {
    return MACHINE_STATUS[status]?.color || '#757575';
  };

  // Makine durumuna göre simge döndürme fonksiyonu
  const getStatusIcon = (status) => {
    return MACHINE_STATUS[status]?.icon || <WarningIcon />;
  };
  
  // Sağlık skoruna göre renk hesaplama
  const getHealthColor = (score) => {
    if (score >= 80) return '#4caf50';
    if (score >= 50) return '#ff9800';
    return '#f44336';
  };
  
  // Seçili makine için sensör verilerini filtrele
  const getFilteredSensorData = () => {
    if (!selectedMachine) return [];
    return selectedMachine.sensorData.filter(data => data.day < timeRange);
  };

  // Bakım planı seçimi
  const handlePlanSelect = (plan) => {
    setSelectedPlan(plan);
    
    // İlgili makineyi de seç
    const machine = machinesData.find(m => m.id === plan.machineId);
    if (machine) {
      setSelectedMachine(machine);
    }
  };
  
  // Bakım planı onaylama
  const handleApprovePlan = () => {
    if (selectedPlan) {
      // Gerçek uygulamada bir API çağrısı yapılırdı
      // Burada sadece UI güncellemesi yapıyoruz
      setSelectedPlan({
        ...selectedPlan,
        approved: true,
        technician: 'Ahmet Yılmaz' // Otomatik atanmış teknisyen
      });
      
      // Planlar listesini güncelle
      const updatedPlans = maintenancePlans.map(plan => 
        plan.id === selectedPlan.id ? 
          {...plan, approved: true, technician: 'Ahmet Yılmaz'} : 
          plan
      );
      
      setMaintenancePlans(updatedPlans);
    }
  };

  return (
    <Container maxWidth="lg">
      <Box sx={{ mb: 4 }} className="slide-in-left">
        <Typography variant="h4" component="h1" gutterBottom fontWeight="bold">
          Prediktif Bakım
        </Typography>
        <Typography variant="subtitle1" color="text.secondary" paragraph>
          Makine arızalarını önceden tespit edin, bakım maliyetlerinizi azaltın ve ekipman ömrünü uzatın.
        </Typography>
        
        {/* Hero görseli ekleyelim */}
        <Box
          component="img"
          src="https://images.unsplash.com/photo-1581091226033-d5c48150dbaa?q=80&w=2070&auto=format&fit=crop"
          alt="Predictive Maintenance"
          sx={{
            width: '100%',
            height: 300,
            objectFit: 'cover',
            borderRadius: 2,
            my: 3
          }}
        />
        
        <Divider sx={{ my: 3 }} />
      </Box>

      {loading ? (
        <Box sx={{ width: '100%', mt: 4, mb: 4 }}>
          <LinearProgress />
          <Typography variant="body2" color="text.secondary" sx={{ mt: 2, textAlign: 'center' }}>
            Makine verileri yükleniyor...
          </Typography>
        </Box>
      ) : (
        <>
          {/* Özet Kartlar */}
          <Grid container spacing={3} sx={{ mb: 4 }}>
            <Grid item xs={12} sm={6} md={3}>
              <Card sx={{ borderRadius: 2, boxShadow: 1 }}>
                <CardContent>
                  <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                    Makine Durumu
                  </Typography>
                  <Stack direction="row" spacing={1} sx={{ mt: 2 }}>
                    <Chip 
                      icon={<CheckCircleIcon />} 
                      label={`${summaryMetrics.healthyCount} Sağlıklı`} 
                      size="small" 
                      color="success" 
                      sx={{ fontWeight: 'bold' }} 
                    />
                    <Chip 
                      icon={<WarningIcon />} 
                      label={`${summaryMetrics.warningCount} İzlenmeli`} 
                      size="small" 
                      color="warning" 
                      sx={{ fontWeight: 'bold' }} 
                    />
                    <Chip 
                      icon={<ErrorIcon />} 
                      label={`${summaryMetrics.criticalCount} Kritik`} 
                      size="small" 
                      color="error" 
                      sx={{ fontWeight: 'bold' }} 
                    />
                  </Stack>
                  <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                    {summaryMetrics.maintenanceCount} makine bakımda
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            
            <Grid item xs={12} sm={6} md={3}>
              <Card sx={{ borderRadius: 2, boxShadow: 1 }}>
                <CardContent>
                  <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                    Ortalama Makine Sağlığı
                  </Typography>
                  <Box sx={{ display: 'flex', alignItems: 'baseline' }}>
                    <Typography 
                      variant="h4" 
                      component="div" 
                      fontWeight="bold" 
                      sx={{ color: getHealthColor(summaryMetrics.avgHealth) }}
                    >
                      <AnimatedNumber 
                        value={summaryMetrics.avgHealth} 
                        suffix="%" 
                        duration={2000} 
                      />
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ ml: 1 }}>
                      sağlık skoru
                    </Typography>
                  </Box>
                  <LinearProgress 
                    variant="determinate" 
                    value={summaryMetrics.avgHealth} 
                    sx={{ 
                      mt: 1, 
                      height: 8, 
                      borderRadius: 1,
                      backgroundColor: 'rgba(0,0,0,0.1)',
                      '& .MuiLinearProgress-bar': {
                        backgroundColor: getHealthColor(summaryMetrics.avgHealth)
                      }
                    }} 
                  />
                </CardContent>
              </Card>
            </Grid>
            
            <Grid item xs={12} sm={6} md={3}>
              <Card sx={{ borderRadius: 2, boxShadow: 1 }}>
                <CardContent>
                  <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                    Ekipman Verimliliği
                  </Typography>
                  <Box sx={{ display: 'flex', alignItems: 'baseline' }}>
                    <Typography 
                      variant="h4" 
                      component="div" 
                      fontWeight="bold"
                    >
                      <AnimatedNumber 
                        value={summaryMetrics.avgEfficiency} 
                        suffix="%" 
                        duration={2000} 
                      />
                    </Typography>
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
                    <TrendingUpIcon color="success" fontSize="small" />
                    <Typography variant="body2" color="success.main" sx={{ ml: 0.5 }}>
                      %4,3 artış (önceki döneme göre)
                    </Typography>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
            
            <Grid item xs={12} sm={6} md={3}>
              <Card sx={{ borderRadius: 2, boxShadow: 1 }}>
                <CardContent>
                  <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                    Arıza Önleme Oranı
                  </Typography>
                  <Box sx={{ display: 'flex', alignItems: 'baseline' }}>
                    <Typography 
                      variant="h4" 
                      component="div" 
                      fontWeight="bold"
                      color="success.main"
                    >
                      <AnimatedNumber 
                        value={summaryMetrics.failurePrevention} 
                        suffix="%" 
                        duration={2000} 
                      />
                    </Typography>
                  </Box>
                  <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
                    <Chip 
                      icon={<NotificationsActiveIcon />} 
                      label={`${summaryMetrics.totalAlerts} uyarı`} 
                      size="small" 
                      color="default" 
                      variant="outlined"
                    />
                  </Stack>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
          
          {/* Ana içerik sekmeleri */}
          <Paper sx={{ borderRadius: 2, mb: 4 }}>
            <Tabs
              value={activeTab}
              onChange={handleTabChange}
              variant="fullWidth"
              sx={{ borderBottom: 1, borderColor: 'divider' }}
            >
              <Tab 
                label="Makine Durumları" 
                icon={<EngineeringIcon />} 
                iconPosition="start" 
              />
              <Tab 
                label="Detaylı Analiz" 
                icon={<AnalyticsIcon />} 
                iconPosition="start" 
                disabled={!selectedMachine}
              />
              <Tab 
                label="Bakım Planlaması" 
                icon={<BuildIcon />} 
                iconPosition="start" 
              />
            </Tabs>
          </Paper>
          
          {/* Sekme İçerikleri */}
          {/* Makine Durumları Sekmesi */}
          {activeTab === 0 && (
            <Box>
              {/* Filtreler */}
              <Paper sx={{ p: 2, mb: 3, borderRadius: 2, display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                <FormControl size="small" sx={{ minWidth: 200 }}>
                  <InputLabel>Lokasyon</InputLabel>
                  <Select
                    value={filter.location}
                    label="Lokasyon"
                    onChange={(e) => handleFilterChange('location', e.target.value)}
                  >
                    <MenuItem value="all">Tüm Lokasyonlar</MenuItem>
                    {locations.map(location => (
                      <MenuItem key={location} value={location}>{location}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
                
                <FormControl size="small" sx={{ minWidth: 200 }}>
                  <InputLabel>Makine Tipi</InputLabel>
                  <Select
                    value={filter.type}
                    label="Makine Tipi"
                    onChange={(e) => handleFilterChange('type', e.target.value)}
                  >
                    <MenuItem value="all">Tüm Tipler</MenuItem>
                    {types.map(type => (
                      <MenuItem key={type} value={type}>{type}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
                
                <FormControl size="small" sx={{ minWidth: 200 }}>
                  <InputLabel>Durum</InputLabel>
                  <Select
                    value={filter.status}
                    label="Durum"
                    onChange={(e) => handleFilterChange('status', e.target.value)}
                  >
                    <MenuItem value="all">Tüm Durumlar</MenuItem>
                    <MenuItem value="HEALTHY">Sağlıklı</MenuItem>
                    <MenuItem value="WARNING">İzlenmeli</MenuItem>
                    <MenuItem value="CRITICAL">Kritik</MenuItem>
                    <MenuItem value="MAINTENANCE">Bakımda</MenuItem>
                  </Select>
                </FormControl>
                
                <Box sx={{ display: 'flex', alignItems: 'center', ml: 'auto' }}>
                  <Typography variant="body2" color="text.secondary" sx={{ mr: 1 }}>
                    {filteredMachines.length} makine gösteriliyor
                  </Typography>
                  <IconButton size="small" sx={{ border: '1px solid #ddd' }}>
                    <RefreshIcon fontSize="small" />
                  </IconButton>
                </Box>
              </Paper>
              
              {/* Makine Kartları */}
              <Grid container spacing={3}>
                {filteredMachines.map(machine => (
                  <Grid item xs={12} sm={6} md={4} key={machine.id}>
                    <Paper
                      sx={{
                        p: 2,
                        borderRadius: 2,
                        cursor: 'pointer',
                        border: selectedMachine?.id === machine.id ? `2px solid ${getStatusColor(machine.status)}` : '1px solid #e0e0e0',
                        boxShadow: selectedMachine?.id === machine.id ? 3 : 1,
                        '&:hover': {
                          boxShadow: 3
                        }
                      }}
                      onClick={() => handleMachineSelect(machine)}
                    >
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                          <Avatar 
                            sx={{ 
                              bgcolor: getStatusColor(machine.status), 
                              mr: 1.5 
                            }}
                          >
                            {getStatusIcon(machine.status)}
                          </Avatar>
                          <Box>
                            <Typography variant="subtitle1" fontWeight="bold">{machine.name}</Typography>
                            <Typography variant="body2" color="text.secondary">{machine.location}</Typography>
                          </Box>
                        </Box>
                        <Chip
                          label={MACHINE_STATUS[machine.status]?.label}
                          size="small"
                          sx={{
                            bgcolor: getStatusColor(machine.status),
                            color: 'white',
                            fontWeight: 'bold'
                          }}
                        />
                      </Box>
                      
                      <Box sx={{ mt: 2, mb: 1 }}>
                        <Typography variant="caption" display="block" color="text.secondary">
                          Sağlık Skoru
                        </Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                          <Box sx={{ flex: 1, mr: 2 }}>
                            <LinearProgress 
                              variant="determinate" 
                              value={machine.healthScore} 
                              sx={{ 
                                height: 8, 
                                borderRadius: 1,
                                backgroundColor: 'rgba(0,0,0,0.1)',
                                '& .MuiLinearProgress-bar': {
                                  backgroundColor: getHealthColor(machine.healthScore)
                                }
                              }} 
                            />
                          </Box>
                          <Typography 
                            variant="body1" 
                            fontWeight="bold" 
                            sx={{ color: getHealthColor(machine.healthScore) }}
                          >
                            {machine.healthScore}%
                          </Typography>
                        </Box>
                      </Box>
                      
                      <Divider sx={{ my: 1.5 }} />
                      
                      <Stack direction="row" justifyContent="space-between" sx={{ mt: 1 }}>
                        <Box>
                          <Typography variant="caption" display="block" color="text.secondary">
                            Çalışma Saati
                          </Typography>
                          <Typography variant="body2">{machine.runningHours} saat</Typography>
                        </Box>
                        <Box>
                          <Typography variant="caption" display="block" color="text.secondary">
                            Verimlilik
                          </Typography>
                          <Typography variant="body2">{machine.efficiency}%</Typography>
                        </Box>
                        <Box>
                          <Typography variant="caption" display="block" color="text.secondary">
                            Bakıma Kalan
                          </Typography>
                          <Typography 
                            variant="body2" 
                            sx={{ 
                              color: machine.daysToMaintenance < 5 ? 'error.main' : 
                                     machine.daysToMaintenance < 15 ? 'warning.main' : 'inherit'
                            }}
                          >
                            {machine.status === 'MAINTENANCE' ? 'Bakımda' : `${machine.daysToMaintenance} gün`}
                          </Typography>
                        </Box>
                      </Stack>
                      
                      {(machine.status === 'CRITICAL' || machine.alertCount > 0) && (
                        <Alert 
                          severity="error"
                          icon={<NotificationsActiveIcon fontSize="inherit" />}
                          sx={{ mt: 2, py: 0.5, fontWeight: machine.status === 'CRITICAL' ? 'bold' : 'normal' }}
                        >
                          {machine.status === 'CRITICAL' 
                            ? `Acil bakım gerekli: ${machine.criticalSystem.name}` 
                            : `${machine.alertCount} aktif uyarı`}
                        </Alert>
                      )}
                    </Paper>
                  </Grid>
                ))}
              </Grid>
            </Box>
          )}
          
          {/* Detaylı Analiz Sekmesi */}
          {activeTab === 1 && selectedMachine && (
            <Box>
              <Paper sx={{ p: 3, mb: 3, borderRadius: 2 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <Typography variant="h6" gutterBottom>
                      {selectedMachine.name} - Sensör Verileri
                    </Typography>
                    <ResponsiveContainer width="100%" height={300}>
                      <LineChart data={getFilteredSensorData()}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="date" />
                        <YAxis />
                        <RechartsTooltip />
                        <Legend />
                        <Line type="monotone" dataKey="vibration" stroke="#8884d8" />
                        <Line type="monotone" dataKey="temperature" stroke="#82ca9d" />
                        <Line type="monotone" dataKey="noise" stroke="#ffc658" />
                        <Line type="monotone" dataKey="pressure" stroke="#ff8042" />
                      </LineChart>
                    </ResponsiveContainer>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Typography variant="h6" gutterBottom>
                      {selectedMachine.name} - Bakım Geçmişi
                    </Typography>
                    <TableContainer component={Paper}>
                      <Table size="small">
                        <TableHead>
                          <TableRow>
                            {TABLE_COLUMNS.map(column => (
                              <TableCell key={column.id} align={column.align}>
                                {column.label}
                              </TableCell>
                            ))}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {selectedMachine.maintenanceHistory.map(row => (
                            <TableRow key={row.id}>
                              {TABLE_COLUMNS.map(column => (
                                <TableCell key={column.id} align={column.align}>
                                  {row[column.id]}
                                </TableCell>
                              ))}
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Grid>
                </Grid>
              </Paper>
            </Box>
          )}
          
          {/* Bakım Planlaması Sekmesi */}
          {activeTab === 2 && (
            <Box>
              {/* Özet Metrikler */}
              <Grid container spacing={3} sx={{ mb: 3 }}>
                <Grid item xs={12} md={3}>
                  <Card sx={{ borderRadius: 2, boxShadow: 1, height: '100%' }}>
                    <CardContent>
                      <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                        Planlı Bakımlar
                      </Typography>
                      <Typography variant="h4" component="div" fontWeight="bold" color="primary.main">
                        <AnimatedNumber value={maintenanceSummary.totalPlans || 0} duration={2000} />
                      </Typography>
                      <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
                        <Chip 
                          label={`${maintenanceSummary.highPriority || 0} Yüksek`} 
                          size="small" 
                          color="error" 
                          variant="outlined"
                        />
                        <Chip 
                          label={`${maintenanceSummary.mediumPriority || 0} Orta`} 
                          size="small" 
                          color="warning" 
                          variant="outlined"
                        />
                        <Chip 
                          label={`${maintenanceSummary.lowPriority || 0} Düşük`} 
                          size="small" 
                          color="success" 
                          variant="outlined"
                        />
                      </Stack>
                    </CardContent>
                  </Card>
                </Grid>
                
                <Grid item xs={12} md={3}>
                  <Card sx={{ borderRadius: 2, boxShadow: 1, height: '100%' }}>
                    <CardContent>
                      <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                        Toplam Bakım Maliyeti
                      </Typography>
                      <Typography variant="h4" component="div" fontWeight="bold">
                        <AnimatedNumber 
                          value={maintenanceSummary.totalCost || 0} 
                          duration={2000} 
                          formatter={(value) => `₺${Number(value).toLocaleString('tr-TR')}`}
                        />
                      </Typography>
                      <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                        Planlanan bakımların toplam maliyeti
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
                
                <Grid item xs={12} md={3}>
                  <Card sx={{ borderRadius: 2, boxShadow: 1, height: '100%' }}>
                    <CardContent>
                      <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                        Tahmini Duruş Süresi
                      </Typography>
                      <Typography variant="h4" component="div" fontWeight="bold">
                        <AnimatedNumber 
                          value={maintenanceSummary.totalDowntime || 0} 
                          duration={2000} 
                          suffix=" saat"
                        />
                      </Typography>
                      <Typography variant="body2" color="success.main" sx={{ mt: 1, display: 'flex', alignItems: 'center' }}>
                        <TrendingUpIcon fontSize="small" sx={{ mr: 0.5 }} />
                        Optimum planlama ile %18 azalma
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
                
                <Grid item xs={12} md={3}>
                  <Card sx={{ borderRadius: 2, boxShadow: 1, height: '100%', bgcolor: 'success.light' }}>
                    <CardContent>
                      <Typography variant="subtitle2" color="white" gutterBottom>
                        Potansiyel Tasarruf
                      </Typography>
                      <Typography variant="h4" component="div" fontWeight="bold" color="white">
                        <AnimatedNumber 
                          value={maintenanceSummary.potentialSavings || 0} 
                          duration={2000} 
                          formatter={(value) => `₺${Number(value).toLocaleString('tr-TR')}`}
                        />
                      </Typography>
                      <Typography variant="body2" color="white" sx={{ opacity: 0.9, mt: 1 }}>
                        Ortalama ROI: %{maintenanceSummary.averageROI || 0}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
              
              {/* Bakım Planları ve Detay Paneli */}
              <Grid container spacing={3}>
                <Grid item xs={12} md={7}>
                  <Paper sx={{ p: 2, borderRadius: 2 }}>
                    <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center' }}>
                      <BuildIcon sx={{ mr: 1 }} /> Yaklaşan Bakım Planları
                    </Typography>
                    
                    <TableContainer sx={{ maxHeight: 550 }}>
                      <Table size="small" stickyHeader>
                        <TableHead>
                          <TableRow>
                            <TableCell width="15%">Tarih</TableCell>
                            <TableCell width="25%">Makine</TableCell>
                            <TableCell width="18%">Bakım Türü</TableCell>
                            <TableCell width="15%" align="right">Maliyet</TableCell>
                            <TableCell width="12%" align="center">Öncelik</TableCell>
                            <TableCell width="15%" align="center">Durum</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {maintenancePlans.map((plan) => (
                            <TableRow 
                              key={plan.id}
                              hover
                              onClick={() => handlePlanSelect(plan)}
                              selected={selectedPlan?.id === plan.id}
                              sx={{ 
                                cursor: 'pointer',
                                borderLeft: plan.priority === 'Yüksek' ? '4px solid #f44336' : 
                                          plan.priority === 'Orta' ? '4px solid #ff9800' : 
                                          '4px solid #4caf50',
                              }}
                            >
                              <TableCell>{plan.plannedDate}</TableCell>
                              <TableCell>
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                  <Box 
                                    sx={{ 
                                      width: 10, 
                                      height: 10, 
                                      borderRadius: '50%', 
                                      bgcolor: getStatusColor(plan.status),
                                      mr: 1
                                    }} 
                                  />
                                  {plan.machineName}
                                </Box>
                              </TableCell>
                              <TableCell>
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                  <Box 
                                    sx={{ 
                                      width: 10, 
                                      height: 10, 
                                      borderRadius: '50%', 
                                      bgcolor: plan.colorCode,
                                      mr: 1
                                    }} 
                                  />
                                  {plan.maintenanceType}
                                </Box>
                              </TableCell>
                              <TableCell align="right">₺{plan.estimatedCost.toLocaleString()}</TableCell>
                              <TableCell align="center">
                                <Chip
                                  label={plan.priority}
                                  size="small"
                                  color={
                                    plan.priority === 'Yüksek' ? 'error' :
                                    plan.priority === 'Orta' ? 'warning' :
                                    'success'
                                  }
                                />
                              </TableCell>
                              <TableCell align="center">
                                {plan.approved ? (
                                  <Chip
                                    label="Onaylandı"
                                    size="small"
                                    color="primary"
                                    variant="outlined"
                                  />
                                ) : (
                                  <Chip
                                    label="Bekliyor"
                                    size="small"
                                    color="default"
                                    variant="outlined"
                                  />
                                )}
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Paper>
                </Grid>
                
                <Grid item xs={12} md={5}>
                  {selectedPlan ? (
                    <Paper sx={{ p: 3, borderRadius: 2, height: '100%' }}>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                        <Typography variant="h6">Bakım Detayları</Typography>
                        {!selectedPlan.approved && (
                          <Button 
                            variant="contained" 
                            color="primary" 
                            size="small"
                            onClick={handleApprovePlan}
                          >
                            Bakımı Onayla
                          </Button>
                        )}
                      </Box>
                      
                      <Box sx={{ mb: 3 }}>
                        <Typography variant="subtitle2" color="text.secondary">Makine Bilgisi</Typography>
                        <Typography variant="body1">{selectedPlan.machineName}</Typography>
                        <Typography variant="body2" color="text.secondary">{selectedPlan.location}</Typography>
                      </Box>
                      
                      <Grid container spacing={2} sx={{ mb: 3 }}>
                        <Grid item xs={6}>
                          <Typography variant="subtitle2" color="text.secondary">Planlanan Tarih</Typography>
                          <Typography variant="body1">{selectedPlan.plannedDate}</Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <Typography variant="subtitle2" color="text.secondary">Tahmini Süre</Typography>
                          <Typography variant="body1">{selectedPlan.estimatedDuration}</Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <Typography variant="subtitle2" color="text.secondary">Bakım Türü</Typography>
                          <Typography variant="body1">{selectedPlan.maintenanceType}</Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <Typography variant="subtitle2" color="text.secondary">Bakım Maliyeti</Typography>
                          <Typography variant="body1">₺{selectedPlan.estimatedCost.toLocaleString()}</Typography>
                        </Grid>
                      </Grid>
                      
                      <Divider sx={{ my: 2 }} />
                      
                      <Box sx={{ mb: 3 }}>
                        <Typography variant="subtitle2" color="text.secondary">Kritik Bileşen</Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
                          <ErrorIcon color="error" fontSize="small" sx={{ mr: 1 }} />
                          <Typography variant="body1">{selectedPlan.criticalComponent.name}</Typography>
                        </Box>
                        <Typography variant="body2" color="text.secondary">
                          Son bakım: {selectedPlan.criticalComponent.lastMaintenanceDate}
                        </Typography>
                      </Box>
                      
                      <Box sx={{ mb: 3 }}>
                        <Typography variant="subtitle2" color="text.secondary">Önerilen İşlemler</Typography>
                        <Box sx={{ pl: 2 }}>
                          {selectedPlan.recommendedActions.map((action, index) => (
                            <Typography key={index} variant="body2" sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
                              • {action}
                            </Typography>
                          ))}
                        </Box>
                      </Box>
                      
                      <Divider sx={{ my: 2 }} />
                      
                      <Box sx={{ mb: 3 }}>
                        <Typography variant="subtitle2" color="text.secondary">Maliyet/Fayda Analizi</Typography>
                        <Grid container spacing={2} sx={{ mt: 1 }}>
                          <Grid item xs={6}>
                            <Paper sx={{ p: 2, bgcolor: 'error.lighter', borderRadius: 2 }}>
                              <Typography variant="caption" color="error.main">Arıza Olasılığı</Typography>
                              <Typography variant="h6" color="error.main">%{selectedPlan.failureProbability}</Typography>
                            </Paper>
                          </Grid>
                          <Grid item xs={6}>
                            <Paper sx={{ p: 2, bgcolor: 'success.lighter', borderRadius: 2 }}>
                              <Typography variant="caption" color="success.main">Bakım ROI</Typography>
                              <Typography variant="h6" color="success.main">%{selectedPlan.roi}</Typography>
                            </Paper>
                          </Grid>
                        </Grid>
                        <Box sx={{ mt: 2 }}>
                          <Typography variant="caption" color="text.secondary">Potansiyel Arıza Maliyeti</Typography>
                          <Typography variant="body1" color="error.main" fontWeight="bold">
                            ₺{selectedPlan.potentialCostOfFailure.toLocaleString()}
                          </Typography>
                        </Box>
                      </Box>
                      
                      {selectedPlan.approved && (
                        <Alert severity="success" sx={{ mt: 2 }}>
                          <Typography variant="body2">
                            Bu bakım {selectedPlan.technician} tarafından gerçekleştirilecek.
                          </Typography>
                        </Alert>
                      )}
                    </Paper>
                  ) : (
                    <Paper sx={{ p: 3, borderRadius: 2, height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <Box sx={{ textAlign: 'center', py: 6 }}>
                        <BuildIcon sx={{ fontSize: 60, color: 'text.disabled', mb: 2 }} />
                        <Typography variant="h6" color="text.secondary">
                          Detaylar için bir bakım planı seçin
                        </Typography>
                      </Box>
                    </Paper>
                  )}
                </Grid>
              </Grid>
            </Box>
          )}
        </>
      )}
    </Container>
  );
};

export default PredictiveMaintenance;
